import { FC } from 'react';

export const ArrowDown: FC<React.HTMLAttributes<HTMLSpanElement>> = (props) => {
  return (
    <span className='grid-picker-arrow down' {...props}>
      <svg
        className='icon'
        width='25px'
        height='25px'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fill='#fff'
          d='M500.8 604.779L267.307 371.392l-45.227 45.27 278.741 278.613L779.307 416.66l-45.248-45.248z'
        />
      </svg>
    </span>
  );
};

export const ArrowLeft: FC<React.HTMLAttributes<HTMLSpanElement>> = (props) => {
  return (
    <span className='grid-picker-arrow left' {...props}>
      <svg
        className='icon'
        width='25px'
        height='25px'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fill='#fff'
          d='M641.28 278.613333l-45.226667-45.226666-278.634666 278.762666 278.613333 278.485334 45.248-45.269334-233.365333-233.237333z'
        />
      </svg>
    </span>
  );
};

export const ArrowRight: FC<React.HTMLAttributes<HTMLSpanElement>> = (
  props,
) => {
  return (
    <span className='grid-picker-arrow right' {...props}>
      <svg
        className='icon'
        width='25px'
        height='25px'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fill='#fff'
          d='M593.450667 512.128L360.064 278.613333l45.290667-45.226666 278.613333 278.762666L405.333333 790.613333l-45.226666-45.269333z'
        />
      </svg>
    </span>
  );
};

export const ArrowUp: FC<React.HTMLAttributes<HTMLSpanElement>> = (props) => {
  return (
    <span className='grid-picker-arrow up' {...props}>
      <svg
        className='icon'
        width='25px'
        height='25px'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fill='#fff'
          d='M500.8 461.909333L267.306667 695.296l-45.226667-45.269333 278.741333-278.613334L779.306667 650.026667l-45.248 45.226666z'
        />
      </svg>
    </span>
  );
};
